export default "__VITE_ASSET__vruJB6yN__"